var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomV2PlayIdeasV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 17.5H3.33333C2.87333 17.5 2.5 17.1267 2.5 16.6667V11.6667C2.5 11.2067 2.87333 10.8333 3.33333 10.8333H5C5.46 10.8333 5.83333 11.2067 5.83333 11.6667V16.6667C5.83333 17.1267 5.46 17.5 5 17.5Z",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M10.8333 14.1667H12.7775C13.1383 14.1667 13.4892 14.05 13.7775 13.8333L15.7908 12.3233C16.2933 11.9467 16.9967 11.9967 17.4408 12.4408V12.4408C17.9342 12.9342 17.9342 13.7333 17.4408 14.2258L15.7133 15.9533C15.2483 16.4183 14.655 16.7358 14.01 16.865L11.5683 17.3533C11.0842 17.45 10.585 17.4383 10.1058 17.3183L7.8975 16.7667C7.63333 16.7 7.3625 16.6667 7.09 16.6667H5.83333",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M10.8333 14.1667H12.0708C12.7683 14.1667 13.3333 13.6017 13.3333 12.9042V12.6517C13.3333 12.0725 12.9392 11.5675 12.3775 11.4275L10.4675 10.95C10.1567 10.8725 9.83833 10.8333 9.51833 10.8333V10.8333C8.74583 10.8333 7.99 11.0617 7.3475 11.4908L5.83333 12.5",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7408 2.93502C16.9625 3.11252 17.6258 4.30669 17.48 5.30836C17.185 7.34086 13.5408 8.51002 13.4791 8.50169C13.4175 8.49252 10.2575 6.33419 10.5525 4.30252C10.6983 3.30086 11.6733 2.34502 12.895 2.52252C13.5933 2.62419 14.005 3.01752 14.2275 3.34669C14.5358 3.09336 15.0425 2.83336 15.7408 2.93502V2.93502Z",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomV2PlayIdeasV2);
export default __webpack_public_path__ + "static/media/customV2PlayIdeasV2.9ca2065dbb8524c5cd861402e2c9d21c.svg";
export { ForwardRef as ReactComponent };